import { ModalContext } from 'app/app';
import { AuthContext } from 'app/auth';
import axios from 'axios';
import { FieldInput } from 'components/fieldInput';
import { ViewContext } from 'components/lib';
import { Form, Formik } from 'formik';
import { Fragment, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import Loader from './images/loader.gif';
import styles from './styles.module.scss';

export function DocumentsModal(props) {
  const { id } = useParams();
  const context = useContext(ViewContext);
  const authContext = useContext(AuthContext);
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('This field is required!'),
    type: Yup.string().required('This field is required!'),
    file: Yup.mixed().required('Document file is required'),
  });

  return (
    <Fragment>
      {modal.name === 'documents_modal' && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>
                {modal.mode === 'edit'
                  ? 'Edit Documents'
                  : 'Add Documents'}
              </div>
              <div className={styles.line} />
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  name: modal.data ? modal.data.name : '',
                  type: modal.data
                    ? modal.data.type.replaceAll(' ', '_')
                    : 'id_card',
                  file: modal.data ? modal.data.link : '',
                }}
                onSubmit={async (values) => {
                  setLoading(true);

                  await axios
                    .get(`/api/company/${id}`)
                    .then(async (res) => {
                      if (modal.data) {
                        const now = new Date();

                        await axios
                          .patch(`/api/document/${modal.data.id}`, {
                            name: values.name,
                            type: values.type,
                            updated_by: authContext.user.name,
                            updated_at: now.toISOString(),
                          })
                          .then(async (r) => {
                            const file =
                              document.getElementById('file')
                                .files[0];

                            if (file) {
                              const form_data = new FormData();
                              form_data.append('file', file);

                              await axios
                                .post(
                                  `/api/document/${modal.data.id}/file`,
                                  form_data,
                                  {
                                    headers: {
                                      'Content-Type':
                                        'multipart/form-data',
                                    },
                                  }
                                )
                                .then((r) => {
                                  context.notification.show(
                                    'Document updated successfully!',
                                    'success',
                                    true,
                                    'toast',
                                    'check-circle'
                                  );
                                })
                                .catch((fileErr) => {
                                  context.notification.show(
                                    'Failed on upload file to server.',
                                    'error',
                                    true,
                                    'toast',
                                    'x-circle'
                                  );
                                });
                            }

                            setLoading(false);
                            setModal({});

                            modal.action();
                          })
                          .catch((err) => {
                            setLoading(false);
                            setModal({});

                            context.notification.show(
                              err.response.data.message,
                              'error',
                              true,
                              'toast',
                              'x-circle'
                            );
                          });
                      } else {
                        await axios
                          .post(`/api/document`, {
                            name: values.name,
                            type: values.type,
                            uploaded_by: authContext.user.name,
                            company_id: res.data.data._id,
                          })
                          .then(async (res) => {
                            const file =
                              document.getElementById('file')
                                .files[0];

                            const form_data = new FormData();
                            form_data.append('file', file);

                            await axios
                              .post(
                                `/api/document/${res.data.data.id}/file`,
                                form_data,
                                {
                                  headers: {
                                    'Content-Type':
                                      'multipart/form-data',
                                  },
                                }
                              )
                              .then((ress) => {
                                setLoading(false);
                                setModal({});

                                context.notification.show(
                                  'Document created successfully!',
                                  'success',
                                  true,
                                  'toast',
                                  'check-circle'
                                );

                                modal.action();
                              })
                              .catch((fileErr) => {
                                context.notification.show(
                                  'Failed on upload file to server.',
                                  'error',
                                  true,
                                  'toast',
                                  'x-circle'
                                );
                              });
                          })
                          .catch((err) => {
                            setLoading(false);
                            setModal({});

                            context.notification.show(
                              err.response.data.message,
                              'error',
                              true,
                              'toast',
                              'x-circle'
                            );
                          });
                      }
                    })
                    .catch((err) => {
                      console.log(err);

                      context.notification.show(
                        'Something went wrong!',
                        'error',
                        true,
                        'toast',
                        'x-circle'
                      );
                    });
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                  setFieldValue,
                }) => (
                  <Fragment>
                    <Form
                      className={styles.form}
                      onSubmit={handleSubmit}
                      encType="multipart/form-data"
                    >
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="name"
                          type="text"
                          label="Name"
                          placeholder="Name"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.name}
                          touched={touched.name}
                          required
                        />
                        <FieldInput
                          id="type"
                          type="select"
                          label="Type"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.type}
                          touched={touched.type}
                          required
                          options={[
                            {
                              value: 'id_card',
                              label: 'ID Card',
                            },
                            {
                              value: 'quote',
                              label: 'Quote',
                            },
                            {
                              value: 'certificates',
                              label: 'Certificates',
                            },
                            {
                              value: 'declaration_page',
                              label: 'Declaration Page',
                            },
                            {
                              value: 'loss_runs',
                              label: 'Loss Runs',
                            },
                            {
                              value: 'mvr',
                              label: 'MVR',
                            },
                            {
                              value: 'other',
                              label: 'Other',
                            },
                          ]}
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="file"
                          type="upload"
                          label="Document file"
                          handleChange={(file) => {
                            handleChange('file');
                            setFieldValue('file', file);
                          }}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.file}
                          touched={touched.file}
                          required
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: 'flex-end' }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal('')}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          onClick={!loading ? submitForm : null}
                          style={
                            loading
                              ? { cursor: 'default' }
                              : { cursor: 'pointer' }
                          }
                        >
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            'Save'
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
